module.exports = __webpack_public_path__ + "static/media/AB_illustration_cards.399774cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/AB_illustration_cards.png
// module id = 595
// module chunks = 0